import React from "react";
// Components
import ListClient from "../../components/EntryPage/ListClient";

function MainBodyContainer() {
  return (
    <div className="flex flex-col">
      <ListClient />
    </div>
  );
}

export default MainBodyContainer;
